<span class="field_form" [class]="item.icon" [ngClass]="item.class ? item.class : ''">
	<span *ngIf="item.title" [innerHtml]="item.title"></span>
	<p *ngIf="item.subTitle">{{ item.subTitle }}</p>
</span>
